import OrderNotesView from 'cart-order-notes.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPackageListingAppState } from '../../redux-state';
import { updateOrderNotes } from '../../redux-state/actions/package-listing.actions';


interface StateToProps {
    orderNotesTitle: string;
    orderNotesPlaceholder: string;
    orderNotesOptionalText: string;
    orderNotes: string;
}


interface DispatchToProps {
    updateOrderNotes: (orderNotes: string) => void;
}

export type OrderNotesProps = StateToProps & DispatchToProps;


export class OrderNotesBase extends React.Component<OrderNotesProps, any> {
    constructor(props: OrderNotesProps) {
        super(props);
    }

    componentDidMount() {
        setTimeout(() => {
            this.props.updateOrderNotes("")
        });
    }

    render() {
        return <OrderNotesView {...this.props} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: OrderNotesProps): StateToProps {
    return {
        orderNotesTitle: state.packageListingText.orderNotesTitle,
        orderNotesPlaceholder: state.packageListingText.orderNotesPlaceholder,
        orderNotesOptionalText: state.packageListingText.orderNotesOptionalText,
        orderNotes: state.packageListing.orderNotes
    }
}

function mapDispatchToProps(dispatch, ownProps: OrderNotesProps): DispatchToProps {
    return {
        updateOrderNotes: (orderNotes) => {
            dispatch(updateOrderNotes(orderNotes));
        }

    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(OrderNotesBase);